<template>
  <div class="compact-empty-state text-xs text-n-slate-10 py-1">
    <span>{{ label }}</span>
    <button
      v-if="actionLabel && actionFn"
      class="compact-empty-state__action"
      @click="actionFn"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CompactEmptyState',
  props: {
    label: {
      type: String,
      required: true,
    },
    actionLabel: {
      type: String,
      default: '',
    },
    actionFn: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style scoped>
.compact-empty-state {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 4px;
  padding-bottom: 4px;
}

.compact-empty-state__action {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  color: inherit;
  text-decoration: underline;
  opacity: 0.8;
}

.compact-empty-state__action:hover {
  opacity: 1;
}
</style>
